import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import DynamicImage from '../dynamic-image/dynamic-image';
import ElementInterpolator from '../element-interpolator/element-interpolator';
import type { NameTag as Props } from './name-tag.types';

const NameTag: React.FC<Props> = ({ highlights, image, template }) => (
  <div className="name-tag">
    <Text elementName="span" size={Text.sizes.basic}>
      <ElementInterpolator
        elements={Object.fromEntries(
          highlights.map(([key, value]) => [
            key,
            <Text
              elementName="span"
              size={Text.sizes.basic}
              theme={Text.themes.emphasis}
              key={value}
            >
              {value}
            </Text>,
          ])
        )}
        template={template}
      />
    </Text>
    {image ? (
      <div className="name-tag__image">
        <DynamicImage
          {...image}
          theme={DynamicImage.themes.round}
          aspectRatio={DynamicImage.aspectRatios.square}
        />
      </div>
    ) : null}
  </div>
);

export default NameTag;
